import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NavigationEnd, Router } from '@angular/router';
import { UtilService } from '../services/util.service';
import { ContatoService } from '../services/contato.service';
import { TitleComponent } from "../components/title/title.component";

@Component({
   selector: 'app-anuncie',
   standalone: true,
   imports: [ReactiveFormsModule, ToastrModule, FormsModule, NgxMaskDirective, CommonModule, TitleComponent],
   templateUrl: './anuncie.component.html',
   styleUrl: './anuncie.component.scss',
   providers: [provideNgxMask()]
})
export class AnuncieComponent {
   form!: FormGroup<{
      nome: FormControl<string>;
      telefone: FormControl<string>;
      email: FormControl<string>;
      endereco: FormControl<string>;
      tipoImovel: FormControl<string>;
      valor: FormControl<string>;
      mensagem: FormControl<string>;
   }>;

   submitted = false;
   isLoading = false;

   destinacoes: any[] = [];
   mobile: boolean = false;

   constructor(
      private utilService: UtilService,
      private contatoService: ContatoService,
      private router: Router,
      private fb: FormBuilder,
      private toastr: ToastrService,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {}

   ngOnInit(): void {
      this.initForm();
      this.buscarSubtiposImoveis();

      if (isPlatformBrowser(this.platformId)) {
         this.checkMobile();
         if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkMobile.bind(this));
         }

         // 🔹 Garante que o scroll acontece depois da renderização
         setTimeout(() => {
            window.scrollTo(0, 0);
         });

         // 🔹 Faz o scroll ao navegar entre páginas
         this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
               setTimeout(() => {
                  window.scrollTo(0, 0);
               });
            }
         });
      }
   }

   private initForm() {
      this.form = this.fb.group({
         nome: ['', Validators.required],
         telefone: ['', Validators.required],
         email: ['', [Validators.required, Validators.email]],
         endereco: ['', Validators.required],
         tipoImovel: ['', Validators.required],
         valor: ['', Validators.required],
         mensagem: ['', Validators.required]
      });
   }

   buscarSubtiposImoveis(): void {
      this.destinacoes = this.utilService
         .fetchSubtipos()
         .map((nome, index) => ({ codigoDestinacao: index, nomeDestinacao: nome }));
   }

   async enviar() {
      console.log('enviar');
      this.submitted = true;

      if (this.form.valid) {
         console.log('Formulário enviado:', this.form.value);
         const body = this.form.value;

         try {
            this.isLoading = true;

            await this.contatoService.criarAnuncieImovel({
               cpf: 'Não informado',
               email: body.email,
               nome: body.nome,
               subTipoImovel: body.tipoImovel,
               telefone: body.telefone,
               tipoContratoVenda: true,
               tipoContratoLocacao: true
            });
            this.toastr.success('Imóvel cadastrado com sucesso!', 'Sucesso');

         } catch (e) {
            console.error(e);
         } finally {
            this.form.reset();
            this.submitted = false;
            this.isLoading = false;
         }

         // Aqui você pode chamar um service para enviar os dados
      } else {
         console.log('Formulário errado:', this.form.value);
         this.form.markAllAsTouched();
      }
   }

   get f() {
      return this.form.controls;
   }

   checkMobile() {
      if (typeof window !== 'undefined') {
         this.mobile = window.innerWidth < 935;
      }
   }

   faqs = [
      {
         pergunta: 'Como faço para anunciar meu imóvel?',
         resposta:
            'Basta preencher o formulário com as informações do seu imóvel e enviar seu cadastro. Nossa equipe entrará em contato.',
         isOpen: false
      },
      {
         pergunta: 'Quanto custa para anunciar?',
         resposta: 'O cadastro do imóvel é gratuito.',
         isOpen: false
      },
      {
         pergunta: 'Posso realizar alterações no anúncio do meu imóvel?',
         resposta: 'Sim, você pode solicitar alterações entrando em contato com uma de nossas agências.',
         isOpen: false
      }
   ];

   toggleAnswer(faq: any) {
      faq.isOpen = !faq.isOpen;
   }
}